import React from 'react';
import { Modal, Image } from 'react-bootstrap';

const ModalShowImages = ({ show, onHide, dataList }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Image Collections</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {dataList && dataList.length > 0 ? (
          dataList.map((item, index) => {
            const images = Object.entries(item)
              .filter(([key, val]) => key.startsWith('image') && typeof val === 'string')
              .map(([_, val]) => val);

            return (
              <div key={index} className="mb-4">
<h5 className="mb-4 text-center text-primary fw-bold">Title: {item.title}</h5>
                <div className="d-flex flex-wrap gap-3">
                  {images.map((img, idx) => (
                    <Image
                      key={idx}
                      src={img}
                      thumbnail
                      alt={`img-${idx}`}
                      style={{ width: '200px', height: '150px', objectFit: 'cover' }}
                    />
                  ))}
                </div>
              </div>
            );
          })
        ) : (
          <p>No image collections available.</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

// const ModalShowVideos = ({ show, onHide, dataList }) => {
  

//   return (
//     <Modal show={show} onHide={onHide} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Video Collections</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {dataList && dataList.length > 0 ? (
//           dataList.map((item, index) => {
//             const urls = Object.entries(item)
//               .filter(([key, val]) => key.startsWith('url') && typeof val === 'string')
//               .map(([_, val]) => val);

//             return (
//               <div key={index} className="mb-5">
//                <h5 className="mb-4 text-center text-primary fw-bold">Title: {item.title}</h5>

//                 <div className="d-flex flex-wrap gap-4">
//                   {urls.map((url, idx) => {
//                     // Extract YouTube video ID and embed
//                     const videoId = new URL(url).searchParams.get('v');
//                     const embedUrl = `https://www.youtube.com/embed/${videoId}`;
//                     return (
//                       <div key={idx} style={{ flex: '1 1 300px', minWidth: '300px' }}>
//                         <iframe
//                           width="100%"
//                           height="200"
//                           src={embedUrl}
//                           title={`video-${index}-${idx}`}
//                           frameBorder="0"
//                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                           allowFullScreen
//                         ></iframe>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             );
//           })
//         ) : (
//           <p>No video collections available.</p>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// };
const ModalShowVideos = ({ show, onHide, dataList }) => {
  // Helper function to detect platform and get embed URL
  const getEmbedUrl = (url) => {
    try {
      const parsedUrl = new URL(url);

      if (parsedUrl.hostname.includes('youtube.com')) {
        const videoId = parsedUrl.searchParams.get('v');
        return { type: 'iframe', url: `https://www.youtube.com/embed/${videoId}` };
      }

      if (parsedUrl.hostname.includes('youtu.be')) {
        const videoId = parsedUrl.pathname.split('/')[1];
        return { type: 'iframe', url: `https://www.youtube.com/embed/${videoId}` };
      }

      if (parsedUrl.hostname.includes('vimeo.com')) {
        const parts = parsedUrl.pathname.split('/');
        const videoId = parts[parts.length - 1].replace(/[^\d]/g, ''); // clean up any trailing characters
        return { type: 'iframe', url: `https://player.vimeo.com/video/${videoId}` };
      }

      // Handle direct video file URLs (MP4, WebM, etc.)
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];
      const hasVideoExtension = videoExtensions.some(ext => 
        parsedUrl.pathname.toLowerCase().includes(ext)
      );
      
      if (hasVideoExtension) {
        return { type: 'video', url: url }; // Return the full URL for direct video files
      }

      return null;
    } catch (e) {
      return null;
    }
  };

  return (
   <Modal show={show} onHide={onHide} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>Video Collections</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {dataList && dataList.length > 0 ? (
      dataList.map((item, index) => {
        const urls = Object.entries(item)
          .filter(([key, val]) => key.startsWith('url') && typeof val === 'string')
          .map(([_, val]) => val);

        return (
          <div key={index} className="mb-5">
            <h5 className="mb-4 text-center text-primary fw-bold">Title: {item.title}</h5>

            <div className="d-flex flex-column gap-4">
              {urls.map((url, idx) => {
                const embedData = getEmbedUrl(url);
                if (!embedData) return null;

                return (
                  <div key={idx} className="w-100">
                    {embedData.type === 'iframe' ? (
                      <iframe
                        width="100%"
                        height="400"
                        src={embedData.url}
                        title={`video-${index}-${idx}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <video
                        width="100%"
                        height="400"
                        controls
                        style={{ borderRadius: '8px' }}
                      >
                        <source src={embedData.url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })
    ) : (
      <p>No video collections available.</p>
    )}
  </Modal.Body>
</Modal>

  );
};


export {ModalShowImages,ModalShowVideos};
